import Footer from 'components/core/Footer';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectFunc } from 'redux/features/auth/authSlice';
import history from 'services/history';

export default function PerfilFunc() {
  const func = useSelector(selectFunc);

  const handleAlterarCelular = () => {
    history.push('/formulario-funcionario', { tipo: 'celular' });
  };

  const handleAlterarSenha = () => {
    history.push('/formulario-funcionario', { tipo: 'senha' });
  };

  const formatarCelularExibicao = (celular) => {
    if (!celular) return 'Não informado';
    const apenasNumeros = celular.replace(/\D/g, '');
    if (apenasNumeros.length === 13) {
      // Formato: +55 14 9 3500-6168
      return `+${apenasNumeros.slice(0, 2)} ${apenasNumeros.slice(2, 4)} ${apenasNumeros.slice(4, 5)} ${apenasNumeros.slice(5, 9)}-${apenasNumeros.slice(9)}`;
    }
    return celular;
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f0f4f8, #d9e2ec)' }}>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} md={6}>
            <Card className="shadow">
              <Card.Body>
                <h4 className="mb-4">Meu Perfil</h4>
                <div className="mb-4">
                  <p className="mb-2">
                    <strong>Nome:</strong> {func?.nome}
                  </p>
                  <p className="mb-2">
                    <strong>CPF:</strong> {func?.cpf}
                  </p>
                  <p className="mb-3">
                    <strong>Celular:</strong> {formatarCelularExibicao(func?.celular)}
                  </p>
                </div>
                <Button className="w-100 mb-2" onClick={handleAlterarCelular}>
                  Alterar Celular
                </Button>
                <Button variant="warning" className="w-100" onClick={handleAlterarSenha}>
                  Alterar Senha
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}
